import { render, staticRenderFns } from "./CategoriesDelete.vue?vue&type=template&id=0054a117&scoped=true"
import script from "./CategoriesDelete.vue?vue&type=script&lang=js"
export * from "./CategoriesDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0054a117",
  null
  
)

export default component.exports